"use client";

import { RichText } from "@payloadcms/richtext-lexical/react";
import ControlsClose from "@workspace/casino_pages/legacyLayer/external/icons/ControlsClose";
import GenericInfo from "@workspace/casino_pages/legacyLayer/external/icons/GenericInfo";
import { Dialog, DialogClose, DialogContent } from "@workspace/frontend-ui";
import type { FC } from "react";
import GenericGlobe from "@/external/icons/GenericGlobe";

type Props = {
  value: unknown;
  translationVpn: string;
  closeable?: boolean;
};

const preventEvent = (e: Event) => e.preventDefault();

const CountryBlockPopupDialog: FC<Props> = ({
  value,
  translationVpn,
  closeable = true,
}) => (
  <Dialog defaultOpen>
    <DialogContent
      showCloseButton={false}
      className="w-full max-w-105 lg:max-w-105 flex flex-col px-4 pt-20 pb-6 gap-4 rounded-2xl"
      onEscapeKeyDown={closeable ? undefined : preventEvent}
      onInteractOutside={closeable ? undefined : preventEvent}
    >
      {closeable && (
        <DialogClose className="absolute top-4 right-4 flex items-center justify-center w-9 h-9 rounded-full border border-border text-foreground">
          <ControlsClose className="w-4 h-4" />
        </DialogClose>
      )}
      <div className="flex flex-col items-center gap-4">
        <div className="flex items-center justify-center w-17 h-17 rounded-full border border-border">
          <GenericGlobe className="w-12 h-12 text-foreground" />
        </div>
        <div className="flex flex-col items-center text-center [&_h1]:text-xl [&_h1]:font-semibold [&_h1]:mb-3 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mb-3 [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:mb-3 [&_p]:text-sm [&_p]:text-muted-foreground">
          {/* biome-ignore lint/suspicious/noExplicitAny: Lexical JSON from CMS is untyped at the GraphQL boundary */}
          <RichText data={value as any} />
        </div>
      </div>
      <div className="w-full flex items-center gap-2 border border-primary bg-secondary rounded-xl px-4 py-3 text-primary text-sm">
        <GenericInfo className="w-5 h-5 shrink-0" />
        <span>{translationVpn}</span>
      </div>
    </DialogContent>
  </Dialog>
);

export default CountryBlockPopupDialog;
